const MoneyFormat = (mount) => {
    return new Intl.NumberFormat("es-CL", {
        style: "currency",
        currency: "CLP",
    }).format(mount);
};

export default MoneyFormat;
